import { useIntl } from "react-intl";
import { useToast } from "@packsize/toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { removeManually } from "@/api/production-api";

import { CLOSING_REQUIRED_JOBS_QUERY_KEY } from "./use-closing-required-cartons";
import { CLOSING_FAILED_JOBS_QUERY_KEY } from "./use-closing-failed-jobs";

export const useRemoveClose = (packagingSolutionId: string, closingId: string) => {
	const intl = useIntl();
	const { toastSuccess, toastError } = useToast();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: () => {
			return removeManually(packagingSolutionId, closingId);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [CLOSING_REQUIRED_JOBS_QUERY_KEY] });
			queryClient.invalidateQueries({ queryKey: [CLOSING_FAILED_JOBS_QUERY_KEY] });
			toastSuccess({
				message: intl.formatMessage({ id: "Remove closing successful", defaultMessage: "Remove closing successful" }),
			});
		},
		onError: (error: unknown) => {
			console.error("Failed to remove closing", error);
			const errorReason =
				(error as { response?: { data?: { errorReason?: string } } })?.response?.data?.errorReason || "Unknown error";
			toastError({
				message: intl.formatMessage(
					{ id: "Failed to remove closing: {errorReason}", defaultMessage: "Failed to remove closing: {errorReason}" },
					{ errorReason },
				),
			});
		},
	});
};
